import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Modal } from "react-bootstrap";

const discount = 0.0;
const BASE_IMAGE_URL = "http://103.235.105.54/admin/uploads/items/";

const Items = () => {
  const [orderType, setOrderType] = useState("take-away");
 const [order, setOrder] = useState(() => {
  const savedOrder = sessionStorage.getItem("order");
  return savedOrder ? JSON.parse(savedOrder) : [];
});

  const [activeCategory, setActiveCategory] = useState("all");
  const [notes, setNotes] = useState("");
  const [customer, setCustomer] = useState("");
  const [error, setError] = useState("");
  const [menuItems, setMenuItems] = useState([]);
  const [orderText, setOrderText] = useState("Order Now");

  const company_id = sessionStorage.getItem("company_id") || 1;
  const branch_id = sessionStorage.getItem("branch_id") || 1;
const [tablesData, setTablesData] = useState([]);
  // Modal states
  const [showVariants, setShowVariants] = useState(false);
  const [selectedVariants, setSelectedVariants] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedAttribute, setSelectedAttribute] = useState(null);
  const [selectedQty, setSelectedQty] = useState(1);

  // Tables
  const [selectedTables, setSelectedTables] = useState(() => {
    const saved = sessionStorage.getItem("selectedTables");
    return saved ? JSON.parse(saved) : [];
  });
  const [tables, setTables] = useState(() => {
    const savedTables = sessionStorage.getItem("tables");
    return savedTables ? JSON.parse(savedTables) : [];
  });

  const navigate = useNavigate();
  useEffect(() => {
      const savedOrder = sessionStorage.getItem("order");
      if (savedOrder) {
        setOrder(JSON.parse(savedOrder));
      }
    }, []);
      useEffect(() => {
    if (order.length > 0) {
      sessionStorage.setItem("order", JSON.stringify(order));
    }
  }, [order]);
  
    useEffect(() => {
          const fetchTables = () => {
            fetch("http://103.235.105.54/admin/api/tables", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                branch_id: sessionStorage.getItem("branch_id"),
                company_id: sessionStorage.getItem("company_id"),
              }),
            })
              .then((res) => res.json())
              .then((data) => {
                console.log("Fetched data:", data);
        
                if (data.status === true && Array.isArray(data.data)) {
                  setTablesData(data.data);
        
     
                }
              })
              .catch((err) => console.error("Fetch error:", err));
          };
        
          fetchTables(); // fetch immediately when page loads
        }, []);
  // --- Load saved order and migrate if needed ---
  useEffect(() => {
    const raw = sessionStorage.getItem("order");
    if (!raw) return;

    try {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) {
        setOrder(parsed);
      } else if (parsed && typeof parsed === "object") {
        const converted = Object.entries(parsed).map(([key, item]) => ({
        //  id: item.item_id ? `${item.item_id}-${item.variant_id || 0}` : `${key}`,
          item_id: item.id ||  null,
          item_name: item.item_name || key,
          attribute: item.attribute || item.variant_name || "",
          tax:Number(item.tax ||  0),
          price: Number(item.baseprice || item.price || 0),
          qty: Number(item.qty || 0),
        }));
        setOrder(converted);
      } else {
        setOrder([]);
      }
    } catch (e) {
      console.error("Failed to parse saved order:", e);
      setOrder([]);
    }
  }, []);
    useEffect(() => {
    const savedType = sessionStorage.getItem("orderType");
    if (savedType) {
      setOrderType(savedType); 
    }
  }, []);
  useEffect(() => {
    try {
      sessionStorage.setItem("order", JSON.stringify(order));
    } catch (e) {
      console.error("Could not save order to sessionStorage:", e);
    }
  }, [order]);

  // Fetch menu items
  useEffect(() => {
    const fetchItems = () => {
      fetch("http://103.235.105.54/admin/api/getitems", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          branch_id: sessionStorage.getItem("branch_id"),
          company_id: sessionStorage.getItem("company_id"),
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.status === "success" && Array.isArray(data.data)) {
            const parsedData = data.data.map((item) => {
              let imgs = item.images;
              try {
                if (typeof imgs === "string") imgs = JSON.parse(imgs);
              } catch {}
              return { ...item, images: imgs || [] };
            });
            setMenuItems(parsedData);
          }
        })
        .catch((err) => console.error("Fetch error:", err));
    };

    fetchItems();
    const interval = setInterval(fetchItems, 10000);
    return () => clearInterval(interval);
  }, []);

  const parseImages = (images) => {
    if (!images) return [];
    if (Array.isArray(images)) return images;
    try {
      const p = typeof images === "string" ? JSON.parse(images) : images;
      return Array.isArray(p) ? p : [];
    } catch {
      return [];
    }
  };

  const handleAddToOrder = () => {
    if (!selectedItem) {
      alert("No item selected.");
      return;
    }
    if (!selectedAttribute) {
      alert("Please select an attribute.");
      return;
    }

   const price = Number(selectedItem.price) || Number(selectedItem.baseprice) || 0;
const igst = Number(selectedItem.igst_percent) || 0;
const vat  = Number(selectedItem.vat_percent) || 0;
const taxp = Number(selectedItem.tax_percent) || 0;

const newEntry = {
  id: `${selectedItem.id}-${selectedAttribute.id}`,
  item_id: selectedItem.id,
  item_name: selectedItem.item_name,
  attribute: selectedAttribute.name,
  images: selectedItem.images,
  percent:parseFloat((igst + vat + taxp) / 100),
  tax: parseFloat(price * (Number(selectedQty) || 1) * (igst + vat + taxp) / 100),
  price,
  qty: Number(selectedQty) || 1,
};
    setOrder((prev) => {
      const idx = prev.findIndex((p) => p.id === newEntry.id);
      if (idx > -1) {
        const copy = [...prev];
        copy[idx] = { ...copy[idx], qty: copy[idx].qty + newEntry.qty };
        return copy;
      }
      return [...prev, newEntry];
    });

    setShowVariants(false);
    setSelectedItem(null);
    setSelectedAttribute(null);
    setSelectedQty(1);
  };

  const deleteItem = (id) => {
    setOrder((prev) => prev.filter((o) => o.id !== id));
  };
  

  const subtotal = order.reduce((acc, o) => acc + (Number(o.price) || 0) * (Number(o.qty) || 0), 0);
const taxRate = order.reduce((acc, o) => {
  if (!o) return acc; // skip null/undefined
  const tax =  (Number(o.price) || 0) * (Number(o.qty) || 0)*o.percent || 0;
  return acc + tax;
}, 0);
  
  const tax = taxRate;
  const total = subtotal + tax - discount;

  const categories = ["all", ...new Set(menuItems.map((i) => i.subcategory_name))];
  const filteredItems = activeCategory === "all" ? menuItems : menuItems.filter((i) => i.subcategory_name === activeCategory);

  const buildOrderPayload = () => {
    const items = order.map((o) => ({
      item_id: o.item_id || (o.id ? Number(String(o.id).split("-")[0]) : null),
      price: o.price,
      qty: o.qty,
      cgst: 0,
      sgst: 0,
      tax: o.tax,
      netprice: (o.price || 0) * (o.qty || 0)+(o.tax),
      attribute: o.attribute || "",
    }));

    return {
      branch_id,
      company_id,
      customer_id: 1,
      customer_name: customer,
      payment_mode: 1,
      order_type: orderType === "dine-in" ? 1 : 2,
      table_id: orderType === "dine-in" ? selectedTables.join(", ") : null,
      notes,
      items,
    };
  };

  const handleOrderNow = async () => {
    if (orderText !== "Order Now") return;
    if (orderType === "take-away" && !customer.trim()) {
      alert("Customer Name is required for Take-Away orders!");
      return;
    }
    if (orderType === "dine-in" && (!selectedTables || selectedTables.length === 0)) {
      alert("Please select tables for dine-in");
      navigate("/table");
      return;
    }

    try {
      const finalOrder = buildOrderPayload();
      console.log("Final order payload:", finalOrder);

      const response = await axios.post("http://103.235.105.54/admin/api/ordersubmit", finalOrder, {
        headers: { "Content-Type": "application/json" },
      });

      if (response.data.status) {
        sessionStorage.removeItem("selectedTables");
        sessionStorage.removeItem("orderType");
        sessionStorage.removeItem("order");
        sessionStorage.removeItem("patrons");
        setSelectedTables([]);
        setOrderType("take-away");
        setOrder([]);
        setCustomer("");
        setOrderText("Order Placed");
        alert("Order Placed Successfully");
        navigate("/table");
      } else {
        setError("Error, Try Again");
      }
    } catch (e) {
      console.error("Order submit error:", e);
      setError("Network/Server error");
    }
  };

  return (
    <main className="main-wrapper">
      <div className="main-content container-fluid">
        <div className="row">
          {/* Menu */}
          <div className="col-md-8">
            <ul className="nav nav-tabs">
              {categories.map((cat) => (
                <li className="nav-item" key={cat}>
                  <button className={`nav-link ${activeCategory === cat ? "active" : ""}`} onClick={() => setActiveCategory(cat)}>
                    {cat}
                  </button>
                </li>
              ))}
            </ul>

            <div className="row g-3 mt-2">
              {filteredItems.map((item) => {
                const imgs = parseImages(item.images);
                const imgSrc = imgs.length > 0 ? BASE_IMAGE_URL + imgs[0] : "assets/images/foods/foods.png";

                return (
                  <div className="col-md-4" key={item.id}>
                    <div className="menu-card"
                    onClick={() => {
                          setSelectedVariants(item.variants || []);
                          setSelectedItem(item);
                          setSelectedAttribute(null);
                          setSelectedQty(1);
                          setShowVariants(true);
                        }}
                    >
                      <img src={imgSrc} alt={item.item_name} />
                      <h6>{item.item_name}</h6>
                      <div className="price">₹{Number(item.baseprice).toFixed(1)}</div>
                      
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Order summary */}
          <div className="col-md-4">
            <h5>Order’s Summary</h5>

            {/* Order type toggle */}
            <div className="mb-3">
              <label className="me-2">Order Type:</label>
              <button className={`btn btn-sm me-2 ${orderType === "take-away" ? "btn-primary" : "btn-outline-primary"}`} onClick={() => setOrderType("take-away")}>
                Take Away
              </button>
              <button className={`btn btn-sm ${orderType === "dine-in" ? "btn-primary" : "btn-outline-primary"}`} onClick={() => setOrderType("dine-in")}>
                Dine In
              </button>
            </div>

            {/* Customer input for take-away */}
            {orderType === "take-away" && (
              <div className="mb-3">
                <label>Customer Name:</label>
                <input className="form-control" value={customer} onChange={(e) => setCustomer(e.target.value)} />
              </div>
            )}

            {/* Table selection for dine-in */}
            {orderType === "dine-in" && (
 <div className="mb-3">
  <label>Selected Tables:</label>
  <div className="d-flex flex-wrap gap-2 mt-2">
    {tablesData
      .filter((t) => selectedTables.includes(t.id)) // ✅ check from all floors
      .map((t) => (
        <label
          key={t.id}
          className="border p-2 rounded"
          style={{ cursor: "pointer",backgroundColor:"#8fdce4",fontSize:"12px" }} 
        >
          {/* <input
            type="checkbox"
            checked={selectedTables.includes(t.id)}
            readOnly
          />
          <br /> */}
          {t.table_code || t.table_name}
        </label>
      ))}
  </div>
</div>
             

            )}

            {/* Items */}
            <div id="order-items">
  <h5>Order Items</h5>
  {order.length === 0 && <p>No items added.</p>}
  {order.map((o) => (
    <div
      key={o.id}
      className="order-item d-flex justify-content-between align-items-center"
    >
      <span>
        {o.item_name} - {o.attribute} (₹{o.price})
      </span>

      <div className="d-flex align-items-center">
        {/* Quantity controls */}
        <button
          className="btn btn-sm btn-outline-secondary"
          onClick={() =>
            setOrder((prev) =>
              prev.map((item) =>
                item.id === o.id && item.qty > 1
                  ? { ...item, qty: item.qty - 1 }
                  : item
              )
            )
          }
        >
          –
        </button>

        <span className="mx-2">{o.qty}</span>

        <button
          className="btn btn-sm btn-outline-secondary"
          onClick={() =>
            setOrder((prev) =>
              prev.map((item) =>
                item.id === o.id
                  ? { ...item, qty: item.qty + 1 }
                  : item
              )
            )
          }
        >
          +
        </button>

        <span className="ms-3">
          ₹{(o.price * o.qty).toFixed(1)}
        </span>

        <button
          className="btn btn-sm btn-danger ms-2"
          onClick={() => deleteItem(o.id)}
        >
          ✖
        </button>
      </div>
    </div>
  ))}
</div>


            <hr />
            <div className="payment-summary">
              <div className="d-flex justify-content-between">
                <span>Price</span>
                <span>₹{subtotal.toFixed(1)}</span>
              </div>
              <div className="d-flex justify-content-between">
                <span>Tax</span>
                <span>₹{tax.toFixed(1)}</span>
              </div>
              
              <hr />
              <div className="d-flex justify-content-between fw-bold">
                <span>Total</span>
                <span>₹{total.toFixed(1)}</span>
              </div>
            </div>

            <div className="mt-3">
              <textarea style={{ width: "100%" }} placeholder="Instructions" onChange={(e) => setNotes(e.target.value)} value={notes} />
              <div className="d-flex gap-2 mt-2">
                <button onClick={handleOrderNow} className="btn btn-primary" disabled={orderText !== "Order Now"}>
                  {orderText}
                </button>
                <button
                  className="btn btn-secondary"
                  onClick={() => {
                    sessionStorage.removeItem("order");
                    setOrder([]);
                  }}
                >
                  Clear Order
                </button>
              </div>
              <p className="text-danger">{error}</p>
            </div>
          </div>
        </div>
      </div>

      {/* Variants Modal */}
      <Modal show={showVariants} onHide={() => setShowVariants(false)} centered dialogClassName="custom-modal-width">
        <div className="modal-header" >
          <h5 className="modal-title"> {selectedItem ? selectedItem.item_name : ""}</h5>
          <button type="button" className="btn-close" onClick={() => setShowVariants(false)} />
        </div>

        <div className="modal-body" >
          <div className="row">
           {/* <div className="col-md-6">
           {(() => {
    const imgs = parseImages(selectedItem ? selectedItem.images : []);
    const imgSrc =
      imgs.length > 0
        ? BASE_IMAGE_URL + imgs[0]
        : "assets/images/foods/foods.png";

    return (
      <div className="quantity-btns d-flex align-items-center mt-3">
        <img
          src={imgSrc}
          alt={selectedItem?.item_name || "Item"}
          className="me-2"
          style={{ width: "150px", height: "150px", objectFit: "cover" }}
        />
      </div>
    );
  })()}
</div> */}
  <div className="col-md-12">
          {selectedVariants && selectedVariants.length > 0 ? (
            selectedVariants.map((v) => (
              <div
                key={v.id}
                className={`mb-2 p-2 border rounded d-flex justify-content-between ${selectedAttribute?.id === v.id ? "bg-primary text-white" : ""}`}
                style={{ cursor: "pointer" }}
                onClick={() => setSelectedAttribute(v)}
              >
                <span>{v.name}</span>
                <span>{v.price ? `₹${v.price}` : ""}</span>
              </div>
            ))
          ) : (
            <p>No variants available</p>
          )}
          </div>
</div>
 <div className="row">
  <div className="col-md-4"></div>
           <div className="col-md-5">
          <div className="d-flex align-items-center mt-3">
            <button className="btn btn-sm btn-outline-secondary" onClick={() => setSelectedQty((q) => Math.max(1, q - 1))}>
              -
            </button>
            <span className="mx-2">{selectedQty}</span>
            <button className="btn btn-sm btn-outline-secondary" onClick={() => setSelectedQty((q) => q + 1)}>
              +
            </button>
          </div>
</div>
           <div className="col-md-3">
          <button className="btn btn-success mt-3" onClick={handleAddToOrder}>
            Add
          </button>
</div>
</div>
        </div>
      </Modal>
    </main>
  );
};

export default Items;
